import connectorUIStore from './connectorUIStore.js';
import connectorDataStore from './connectorDataStore.js';

export default {
  modules: {
    ui: connectorUIStore,
    data: connectorDataStore,
  },
};
